/**
 * @author yyl
 * 功能：查询公司信息
 */

import { Service } from '@/tools'

export class CustomerCompanyService<T extends TCustomer.Company> extends Service {
  constructor(path: string) {
    super()
    this.setPathPrefix(path)
  }

  private post2<P extends TCommon.ApiVersion = 'v1'>(url: `${P}/${keyof TCustomer.Company}`, data?: TCommon.Json, toast?: string) {
    return this.post(url, data, toast)
  }
  private postUpload<P extends TCommon.ApiVersion = 'v1'>(url: `${P}/${keyof TCustomer.Company}`, data?: TCommon.Json, toast?: string) {
    return this.post(
      {
        url: url,
        headers: {
          'Content-type': 'multipart/form-data',
        },
        method: 'post',
        data: data,
      },
      data,
      toast
    )
  }

  //查询公司和小连锁公司列表
  // /api/customer/customer/v1/allCustomers
  allCustomers = <K extends T['ApiAllCompanies']>(): Promise<K['res']> => this.post2('v1/ApiAllCompanies', {})

  //分页查询公司信息列表
  companyPage = <K extends T['ApiCompanyPage']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiCompanyPage', data)

  //编辑公司信息
  updateCompany = <K extends T['ApiUpdateCompany']>(data: K['req']): Promise<K['res']['data']> => this.post2('v1/ApiUpdateCompany', data)

  //新增公司信息
  addCompany = <K extends T['ApiAddCompany']>(data: K['req']): Promise<K['res']['data']> => this.post2('v1/ApiAddCompany', data)

  //删除公司信息
  deleteCompany = <K extends T['ApiDeleteCompany']>(data: K['req']): Promise<K['res']['data']> => this.post2('v1/ApiDeleteCompany', data)

  //导入公司信息
  companyImport = <K extends T['ApiCompanyImport']>(data: K['req']): Promise<K['res']> => this.postUpload('v1/ApiCompanyImport', data)

  //公司详情
  companyDetail = <K extends T['ApiCompanyDetail']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiCompanyDetail', data)

  //公司选择器
  allCompanies = <K extends T['ApiAllCompanies']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiAllCompanies', data)
  // 查询登录人所属公司组织关联的公司结算信息
  getCompanyInfoByOrgId = <K extends T['ApiGetCompanyInfoByOrgId']>(): Promise<K['res']> => this.post2('v1/ApiGetCompanyInfoByOrgId')
}
